import { useEffect } from 'react'
import { TablePagination } from '@mui/material'
import { FKSP_PAGE_SIZE } from '../lib/fkspConstants'

type Props = {
  count: number
  page: number
  onPageChange: (page: number) => void
  pageSize?: number
}

/** Paginace seznamů FKSP — pevně 300 řádků na stránku. */
export function FkspTablePagination({
  count,
  page,
  onPageChange,
  pageSize = FKSP_PAGE_SIZE,
}: Props) {
  const maxPage = Math.max(0, Math.ceil(count / pageSize) - 1)
  const safePage = Math.min(Math.max(0, page), maxPage)

  useEffect(() => {
    if (safePage !== page) onPageChange(safePage)
  }, [safePage, page, onPageChange])

  if (count <= pageSize) return null

  return (
    <TablePagination
      component="div"
      count={count}
      page={safePage}
      onPageChange={(_e, next) => onPageChange(next)}
      rowsPerPage={pageSize}
      rowsPerPageOptions={[pageSize]}
      labelRowsPerPage="Na stránku:"
      labelDisplayedRows={({ from, to, count: total }) => `${from}–${to} z ${total}`}
      sx={{ borderTop: 1, borderColor: 'divider', '.MuiToolbar-root': { minHeight: 44 } }}
    />
  )
}

export function fkspPageSlice<T>(items: T[], page: number, pageSize = FKSP_PAGE_SIZE): T[] {
  const safePage = Number.isFinite(page) && page > 0 ? page : 0
  const start = safePage * pageSize
  return items.slice(start, start + pageSize)
}
